import React, { useState, useMemo } from "react";
import { useTranslation } from "react-i18next";
import BasicTable from "../../components/UiComponent/customTable";
import {
  get_branch_target,
  RegisterBranchTarget,
  UpdateBranchTarget,
  get_target_taype,
  get_branch_data,
} from "../../services/employeeApi";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { GetUserInfo, hasAccess } from "../../utils/permissionChecker";
import { toast } from "react-toastify";
import { Modal, Row, Form, Col, Button, Spinner } from "react-bootstrap";
import { formatDate } from "../../utils/date_utils";
const BranchAmbasadorTarget = () => {
  const { t } = useTranslation();
  const user = GetUserInfo();
  const currentUser =
    user.employee.first_name + " " + user.employee.father_name;
  const queryClient = useQueryClient();
  const [showModal, setShowModal] = useState(false);
  const handleShowModal = () => {
    setShowModal(true);
    setFormError("");
  };
  const handleCloseModal = () => {
    setShowModal(false);
    setIsUpdateMode(false);
  };
  const [formError, setFormError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isUpdateMode, setIsUpdateMode] = useState(false);
  const [formData, setFormData] = useState({
    branch_id: "",
    target_type_id: "",
    target_amount: 0,
    from_date: "",
    to_date: "",
    status: true,
    created_by: currentUser,
  });
  const RegisterTaskTargetMutation = useMutation(async (newData) => {
    try {
      let result;
      if (isUpdateMode) {
        result = await UpdateBranchTarget(newData);
      } else {
        result = await RegisterBranchTarget(newData);
      }
      if (result) {
        queryClient.invalidateQueries("get_branch_target");
        toast.success(result.message, {
          position: "top-right",
          autoClose: 4000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        handleCloseModal();
      }
    } catch (error) {
      toast.error(error.message, {
        position: "top-right",
        autoClose: 6000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
  });
  const { data, isLoading, isError, error } = useQuery(
    ["get_branch_target"],
    async () => {
      const getBranchTarget = await get_branch_target();
      const getbranches = await get_branch_data();
      const gettargetTaype = await get_target_taype();
      return {
        branchTarget: getBranchTarget,
        branche: getbranches,
        targetGoalTaype: gettargetTaype,
      };
    }
  );

  const targetData = useMemo(() => {
    return data?.branchTarget || [];
  }, [data]);
  const targetTaype = useMemo(() => {
    return data?.targetGoalTaype || [];
  }, [data]);

  const branchData = useMemo(() => {
    return data?.branche || [];
  }, [data]);

  if (isLoading) {
    return <div>Loading...</div>;
  }
  if (isError) {
    return <div>Error: {error.message}</div>;
  }
  const toDateInputValue = (date) => (date ? date.split("T")[0] : "");
  const Update = (event, rowData) => {
    event.preventDefault();
    setFormData({
      id: rowData.id,
      branch_id: rowData.branch_id,
      target_type_id: rowData.target_type_id,
      target_amount: rowData.target_amount,
      from_date: toDateInputValue(rowData.from_date),
      to_date: toDateInputValue(rowData.to_date),
      status: rowData.status,
      created_by: rowData.created_by,
      updated_by: currentUser,
    });
    setIsUpdateMode(true);
    handleShowModal();
  };
  const handleButtonSubmit = async (e) => {
    e.preventDefault();
    if (
      !formData.branch_id ||
      !formData.from_date ||
      !formData.target_type_id ||
      !formData.target_amount
    ) {
      setFormError("Pease fill all fields are required ");
      return;
    }
    try {
      setIsSubmitting(true);
      await RegisterTaskTargetMutation.mutate(formData);
    } finally {
      setIsSubmitting(false);
    }
  };
  const handleInputChange = (e, fieldName) => {
    const { value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [fieldName]: value,
    }));
  };
  let brachTargetTableColumns = [
    {
      header: "branch",
      accessorKey: "branch_name",
    },
    {
      header: "target",
      accessorKey: "target_type_name",
    },
    {
      header: "quantity",
      accessorKey: "target_amount",
    },
    {
      header: "start_date",
      accessorFn: (row) => `${formatDate(row.from_date)} `,
    },
    {
      header: "end_date",
      accessorFn: (row) => `${formatDate(row.to_date)} `,
    },
  ];
  // 👉 Add Action column ONLY if admin
  if (hasAccess(["administrator"], user.accessRole)) {
    brachTargetTableColumns.push({
      header: "Action",
      accessor: "id",
      cell: (row) => (
        <div className="d-flex justify-content align-items-center">
          <Button
            variant="btn btn-info btn-sm"
            onClick={(e) => Update(e, row.row.original)}
          >
            {t("update")}
          </Button>
        </div>
      ),
    });
  }
  console.log(targetData);
  return (
    <>
      <BasicTable
        data={targetData}
        columns={brachTargetTableColumns}
        title={`BA Target Per Branch`}
        actionButton={
          hasAccess(["administrator"], user.accessRole) ? (
            <Button
              variant="btn btn-info btn-sm"
              onClick={() => handleShowModal()}
            >
              {t("add_new_Target")}
            </Button>
          ) : (
            ""
          )
        }
      />
      <Modal
        show={showModal}
        onHide={handleCloseModal}
        centered={true}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title as="h5">
            {isUpdateMode ? "Update the target" : "Register new target"}{" "}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Row>
              <Col lg="12">
                <Form.Group>
                  <Form.Label
                    htmlFor="inputPosition"
                    className="font-weight-bold text-muted"
                  >
                    {t("branch")}
                  </Form.Label>
                  <select
                    id="inputPosition"
                    className="form-select form-control choicesjs"
                    value={formData.branch_id}
                    onChange={(e) => handleInputChange(e, "branch_id")}
                  >
                    <option value="" hidden disabled>
                      Select Branch
                    </option>
                    {branchData.map((data) => (
                      <option key={data.id} value={data.id}>
                        {data.name}
                      </option>
                    ))}
                  </select>
                </Form.Group>

                <Form.Group>
                  <Form.Label
                    htmlFor="inputPosition"
                    className="font-weight-bold text-muted"
                  >
                    {t("Target Taype")}
                  </Form.Label>
                  <select
                    id="inputPosition"
                    className="form-select form-control choicesjs"
                    value={formData.target_type_id}
                    onChange={(e) => handleInputChange(e, "target_type_id")}
                  >
                    <option value="" hidden disabled>
                      Select Target Taype
                    </option>
                    {targetTaype.map((data) => (
                      <option key={data.id} value={data.id}>
                        {data.name}
                      </option>
                    ))}
                  </select>
                </Form.Group>
                <Form.Group>
                  <Form.Label className="text-secondary">
                    Targt Quntity
                  </Form.Label>
                  <Form.Control
                    type="number"
                    placeholder="Enter Quntity targt"
                    value={formData.target_amount}
                    onChange={(e) => handleInputChange(e, "target_amount")}
                  />
                </Form.Group>
                <Form.Group>
                  <Form.Label className="text-secondary">Start date</Form.Label>
                  <Form.Control
                    type="date"
                    placeholder="Enter target start date"
                    value={formData.from_date}
                    onChange={(e) => handleInputChange(e, "from_date")}
                  />
                </Form.Group>
                <Form.Group>
                  <Form.Label className="text-secondary">To date</Form.Label>
                  <Form.Control
                    type="date"
                    placeholder="Enter target end date"
                    value={formData.to_date}
                    onChange={(e) => handleInputChange(e, "to_date")}
                  />
                  <p className="text-danger"> {formError}</p>
                </Form.Group>
              </Col>
            </Row>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Close
          </Button>
          {isSubmitting ? (
            <Button className="btn btn-info">
              <Spinner
                as="span"
                animation="grow"
                size="sm"
                role="status"
                aria-hidden="true"
              />
              <span className="visually-hidden">Sending...</span>
            </Button>
          ) : (
            <Button
              className="btn btn-info"
              onClick={(e) => handleButtonSubmit(e)}
            >
              {isUpdateMode ? "Update" : "Register"}
            </Button>
          )}
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default BranchAmbasadorTarget;
